import { __assign } from "tslib";
import { createStyleParamGetter } from './styles/createStyleParamGetter';
import { decodeWixStyles } from './styles/decodeWixStyles';
export function getStylesValues(styles, params, options) {
    if (options === void 0) { options = {}; }
    var acc = {};
    Object.keys(params).forEach(function (paramKey) {
        var param = params[paramKey];
        acc[param.key] = createStyleParamGetter(__assign({ storage: decodeWixStyles(styles, options.colors || [], options.textPresets || {}) }, options))(param);
    });
    return acc;
}
//# sourceMappingURL=getStylesValues.js.map